
// App

(function(){

	var app = {

		checkTouch: function() {

			if ( ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch ) {

				this.el.classList.remove( 'app_no_touch' );
				this.el.classList.add( 'app_touch' );
				this.touch = true;

			} else {

				this.touch = false;
			}

		},

		click: function(e) {

			var el = e && e.target;
			var parent = el && el.parentNode;

			if ( el && el.hash || parent && parent.hash ) {

				var to = document.querySelector( el.hash || parent.hash );

				if ( to && typeof to.offsetTop === 'number' ) {

					e.preventDefault();

					if ( this.scrollBehavior ) return window.scroll( {
						top: to.offsetTop,
						left: 0,
						behavior: 'smooth'
					});

					window.scrollTo( 0, to.offsetTop );

				}

			}

		},

		addClosestPolyfill: function ( ElementProto ) {

			if ( typeof ElementProto.matches !== 'function' ) {

				ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches( selector ) {

					var element = this,
						elements = ( element.document || element.ownerDocument ).querySelectorAll( selector ),
						index = 0;

						while ( elements[index] && elements[index] !== element ) {
							++index;
						}

						return Boolean( elements[index] );
				};

			}

			if ( typeof ElementProto.closest !== 'function' ) {

				ElementProto.closest = function closest( selector ) {

					var element = this;

						while ( element && element.nodeType === 1 ) {

							if ( element.matches( selector ) ) return element;

							element = element.parentNode;

						}

						return null;

				};

			}

		},

		init: function() {

			this.el = document.querySelector( '.app' );

			if ( !this.el ) return

			this.el.classList.remove( 'app_no_js' );
			this.el.classList.add( 'app_js' );

			this.scrollBehavior = 'scrollBehavior' in document.documentElement.style;

			this.checkTouch();
			this.addClosestPolyfill( window.Element.prototype );

			document.addEventListener( 'click', this.click.bind( this ) );

			return this;

		}

	}

	return app.init();

})();
